var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTongyongGonggao(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 5.5a.5.5 0 01.5-.5h11a.5.5 0 01.5.5v8a.5.5 0 01-.5.5h-11a.5.5 0 01-.5-.5v-8z",
    stroke: "#3F465C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.5 8H11M4.5 10.5H8",
    stroke: "#3F465C",
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.3 5.4L8 2.625l-.6-.8L3.7 4.6l.6.8zM8 2.625L11.7 5.4l.6-.8-3.7-2.775-.6.8zm0 0l.6-.8a1 1 0 00-1.2 0l.6.8z",
    fill: "#3F465C"
  })));
}
export default __webpack_public_path__ + "static/tongyong_gonggao.b7accc4c.svg";
export { SvgTongyongGonggao as ReactComponent };